module.exports = __webpack_public_path__ + "homeAbout_uroven.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/homeAbout_uroven.jpg
// module id = 900
// module chunks = 0